import {Link} from 'react-router-dom';
import './ProjectCard.scss'
import { useSelector } from 'react-redux';
import { selectUserStudio } from '../../../app/slices/authSlice';
import { getThumbnailUrl } from '../../../utils/urlUtils';
import { convertMegabytes, shortenText } from '../../../utils/stringUtils';
import ProjectExpiration from '../../ProjectExpiration/ProjectExpiration';

function ProjectCard({project,type}) {   
  const defaultStudio = useSelector(selectUserStudio)
  return (
    <Link className={`project 
        ${project.id} 
        ${project.type?project.type:''} 
        ${project.status?project.status:''}
        ${project.storage?.status === 'archive' ? 'archive' : ''}
        ${type?type:''} 
        `} 
        to={`/${defaultStudio.domain}/project/${project.id}`} key={project.id}
    >
        <div className="cover-wrap">
            <div className="project-cover"
            style={{
                backgroundImage: project.projectCover ? `url(${getThumbnailUrl(project.projectCover).replace(/\(/g, '%28').replace(/\)/g, '%29')})` : '',
                backgroundSize: project.projectCover ? 'cover' : '',
                backgroundBlendMode: project.projectCover ? '' : 'soft-light',
            }}
            />
        </div>
        <div className="project-details">
            <div className="details-top">
                <div className="left">
                    <p className="project-type">{shortenText(project.type, 10)}</p>
                    <h4 className="project-title">{project.name}</h4>
                    <ProjectExpiration 
                        createdAt={project.createdAt} 
                        status={project.storage.status}
                        projectValidityMonths={project.projectValidityMonths}
                        fileRetentionYears={project.fileRetentionYears}
                        archiveThreshold={project.storage?.archiveThreshold}
                        expiryDate={project.storage?.expiryDate}
                    />
                    <div className="info-bar">
                        <div className="tags">
                        {project?.events?.length > 0 && (
                        <div className="event-dates">
                            {project.events.slice(0, 1).map((event, index) => (
                            event?.date && (
                                <p key={index} className="project-dates tag">
                                {new Date(event.date).toLocaleString('default', {
                                    day: 'numeric',
                                    month: 'short',
                                })}
                                </p>
                            )
                            ))}
                            {project.events.length > 2 && (
                            <p className="project-dates tag extra"> 
                                 +{project.events.length - 1}
                            </p>
                            )}
                        </div>
                        )}
                        {project?.budgets?.amount &&<p className=" project-budget tag"> ₹ {project?.budgets?.amount}</p>}
                        </div>
                       {/*  open in Lightroom  */}
                       <div className={`button lr mini ${project.status==="selected"?'':'disabled'}`}>Lr</div>
                    </div>
                </div>
                <div className="right">
                    <div className="status-signal"></div>
                </div>
            </div>
            { project.collections.length === 0 ?
                <div className="empty-message">Upload your snaps</div> :
                <div className="project-summary">
                    <div className="summary-left">
                        <div className="pin">
                            <p className="disk-label"></p>
                            <p className="pin-number">{convertMegabytes(project.totalFileSize)}</p>
                        </div>
                        <div className={`summary-item collection-count ${project.collections.length>0?'active':''}`}>
                            <div className="icon"></div>
                            <p>{project.collections.length}</p>
                        </div>
                        <div className={`summary-item photos-count ${project.uploadedFilesCount>0?'active':''}`}>
                            <div className="icon"></div>
                            <p>{project.uploadedFilesCount}</p>
                        </div>
                    </div>
                    <div className="summary-right">     
                    
                    </div>
                </div>
            }
        </div>
        
    </Link>
    );
}

    export default ProjectCard;
